import { Component, Input, Output } from '@angular/core';
import { DataTableActionBtnConfig, DataTableColumnConfig } from '@mavles/shared';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss'],
    standalone: false
})
export class DataTableComponent {
  @Input() data: any[] = [];
  @Input() columns: DataTableColumnConfig[] = [];
  @Input() buttons: DataTableActionBtnConfig[] = [];
  @Output() action = new EventEmitter<any>();

  sortColumn = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  filters: { [key: string]: any } = {};



  onSort(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  }

  onFilter(column: string, event: any): void {
    this.filters[column] = event.target.value;
  }

  getSortIcon(column: string): string {
    if (this.sortColumn === column) {
      return this.sortDirection === 'asc'
        ? 'bi bi-caret-up-fill'
        : 'bi bi-caret-down-fill';
    }
    return 'bi bi-filter-circle';
  }

  

  get filteredData(): any[] {
    let filteredData = this.data;


    // Filters
    for (const field in this.filters) {
      if (this.filters[field]) {
        filteredData = filteredData.filter((item) =>
          item[field]
            .toString()
            .toLowerCase()
            .includes(this.filters[field].toLowerCase())
        );
      }
    }

    // Sorting
    if (this.sortColumn) {
      filteredData.sort((a, b) => {
        const valueA = a[this.sortColumn].toString().toLowerCase();
        const valueB = b[this.sortColumn].toString().toLowerCase();
        if (valueA < valueB) {
          return this.sortDirection === 'asc' ? -1 : 1;
        }
        if (valueA > valueB) {
          return this.sortDirection === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    return filteredData;
  }

  onClickExecute(data: any, btn?: any): void {
    this.action.emit({ data, btn });
  }
}


